export default __webpack_public_path__ + "static/logo-6c7ef42b6a51e44f0e0682674091de2e.svg";